import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import Modal from "react-responsive-modal";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { useSelector } from "react-redux";
import { CheckStoreAreaDeliveryAvailable } from "../../../utils/CheckDeliveryAvailable";
import {
  formInitialValues3,
  formSchemaInitial3,
} from "../../MyAddress/MyAddressValidation";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import addressFactor, {
  extractUAEAddressDetails,
} from "../../../utils/AddressFactor";
import { useTranslation } from "react-i18next";
import AddressTypeSelector from "../AddressTypeSelector";
import axiosInstance from "../../../Axios-Config/Axios-Config";
import { useDispatch } from "react-redux";
import { SETLOADER } from "../../../redux/features/common";
import { GetAllAddress } from "../../../api/GetAddress";
import { SuccessToast } from "../../ToastComponent/SuccessToast";
import LoaderButton from "../../Buttons/LoaderButton";
import {
  returnAddressFormJson,
  setErrorCustom,
  setMinimumPriceAndAddressData,
} from "./googleAddressutils";
import { SETMINORDERDELIVERYPRICE } from "../../../redux/features/CartData";
import { setSelectedAddress } from "../../../redux/features/CheckoutAddress";

import { render } from "@testing-library/react";

let arraddressSelectType = ["SAVED", "FORM"];
const AddressGoogleSearch = ({
  refrencePage,
  addressModal,
  setAddressModal,
  actionType,
  selectedAddress,
}: {
  addressModal: boolean;
  setAddressModal: (addressModal: any) => void;
  actionType: any;
  selectedAddress: any;
  refrencePage?: string;
}) => {
  const reduxStore = useSelector((state: any) => state);
  const {
    addressData: { address },
    store: { selectedStore },
    checkoutAddress,
    commonData: { loader },
  } = reduxStore;
  // console.log("reduxStore", reduxStore, selectedStore)

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [googleAPIReady, setGoogleAPIReady] = useState(false);
  const [isRender, setIsRender] = useState(true);
  const [selectSavedAddress, setSelectSavedAddress] = useState("");

  const [addressSelectFormType, setAddressSelectFormType] = useState(
    arraddressSelectType[1]
  );
  const [savedAddressMinPrice, setSavedAddressMinPrice] = useState("");
  const [savedSelectedData, setSavedSelectedData] = useState("");
  const [isSavedChange, setIsSavedChange] = useState(false);
  // setIsDeliveryAllowFunData
  const [isDeliveryAllowFunData, setIsDeliveryAllowFunData] = useState<any>("");
  const isAddressAddEdit = refrencePage == "MyAddressView";

  const {
    handleSubmit,
    formState: { errors },
    trigger,
    register,
    setValue,
    getValues,
    clearErrors,
    setError,
  } = useForm({
    resolver: yupResolver(formSchemaInitial3),
    defaultValues: formInitialValues3,
  });

  // @@ google map loaded
  useEffect(() => {
    handleLoaded();
  }, []);

  useEffect(() => {
    // @@ for fetching address from api
    if (!address?.length) {
      GetAllAddress(dispatch);
    }
  }, []);
  useEffect(() => {
    // @@ already selected address
    if (refrencePage == "DeliveryView" && checkoutAddress?.selectedAddress) {
      const uniqueAddress = `${checkoutAddress?.selectedAddress?.zip_code}${checkoutAddress?.selectedAddress?.full_address}`;
      setSelectSavedAddress(uniqueAddress);
      setAddressSelectFormType(arraddressSelectType[0]);
    }
  }, []);

  // @@ set form value
  function setAddressValue(addressObj: any) {
    setValue(
      "full_address",
      addressObj?.full_address ? addressObj?.full_address : ""
    );
    setValue("address_type", addressObj?.address_type || "Home");
    // setValue("zip_code", addressObj?.zip_code);

    setValue("country", addressObj?.country);

    setValue("street_name", addressObj?.street_name);
    setValue("city", addressObj?.city);
    setValue("house_no", addressObj?.house_no);
    setValue("longitude", addressObj?.longitude);
    setValue("lattitude", addressObj?.lattitude);

    // @@ remove error from not null value
    for (let item in addressObj) {
      let msg = addressObj[item];
      if (msg) {
        setErrorCustom(setError, item, "");
      }
    }
    setIsRender(!render);
  }

  useEffect(() => {
    if (actionType == "ADD") {
      setValue("address_type", "Home");
    } else {
      const addressObj = selectedAddress;
      setValue("id", addressObj?.id);
      setAddressValue(addressObj);
    }
  }, [actionType, checkoutAddress]);

  // @@ google map loaded
  const handleLoaded = () => {
    if (!window.google) {
      const existingScript = document.querySelector(
        'script[src^="https://maps.googleapis.com/maps/api/js"]'
      );
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLEMAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          setGoogleAPIReady(true);
        };
        script.onerror = () => {
          console.error("Error loading Google Maps API");
        };
        document.body.appendChild(script);
      } else {
        setGoogleAPIReady(true);
      }
    } else {
      setGoogleAPIReady(true);
    }
  };

  if (!googleAPIReady) {
    return <div>Loading Google Maps...</div>;
  }

  // @@ modal close
  const handleClose = () => {
    setAddressModal(!addressModal);
  };

  // @@ selected address type and minimum price data saved
  const clearAndSetSavedData = (
    selectedAddressMinPrice: any,
    selectedSavedAddress: any,
    selectFormType: any
  ) => {
    setSavedAddressMinPrice(selectedAddressMinPrice);
    setSavedSelectedData(selectedSavedAddress);
    setAddressSelectFormType(selectFormType);
  };

  // @@ address search onChange
  const handleChange = (e: any) => {
    // if (e) {
    setAddressValue({ full_address: e ? e : "" });
    setValue("full_address", e ? e : "");
    setIsRender(!isRender);
    // } else {

    //     setAddressValue({})
    // }
    setSelectSavedAddress("");
    clearAndSetSavedData("", "", arraddressSelectType[1]);
  };
  // RQHM+94G, Fareham, UK
  // 17 Cromarty Close, Fareham, PO14 3QX, England
  //     150 - 180) Old Street, Hill Head, Fareham, PO14 3HQ
  // Hill Head Fareham England United Kingdom

  // @@ search address select
  const handleSelect = async (selectAdd: any) => {
    let selectAddress = selectAdd;
    setAddressValue({ full_address: selectAddress });

    try {
      // Geocode the selected address and retrieve coordinates
      const results = await geocodeByAddress(selectAddress);
      // console.log("results", results)
      const latLng = await getLatLng(results[0]);
      // console.log('latLng',latLng,results)
      // console.log('Coordinates: ', results, latLng);
      if (results?.length < 0 && results.length == 0) {
        setErrorCustom(
          setError,
          "full_address",
          "The address is still outside of our delivery area. You can try a different address."
        );
        setAddressValue({});
        return;
      }
      let isDeliveryAllow = CheckStoreAreaDeliveryAvailable(
        latLng,
        selectedStore
      );
      if (!isDeliveryAllow?.status) {
        setErrorCustom(
          setError,
          "full_address",
          "The address is still outside of our delivery area. You can try a different address."
        );
        setAddressValue({});
        return;
      }
      let addressValue = results?.[0];
      let formatedAddress = extractUAEAddressDetails(addressValue);
      setAddressValue({
        ...formatedAddress,
        longitude: latLng?.lng,
        lattitude: latLng?.lat,
      });
      setIsDeliveryAllowFunData(isDeliveryAllow?.matchedAreaData);
    } catch (error) {
      // console.error('Error getting coordinates: ', error);
    }
  };

  // @@ saved adress select
  const onHandleDropDownClick = async (e1: any, e: any, uniqueAddress: any) => {
    e1.preventDefault();
    // console.log("eeeee", e, e1, uniqueAddress);
    let latLng = {
      lat: Number(e?.lattitude),
      lng: Number(e?.longitude),
    };
    let isDeliveryAllow = CheckStoreAreaDeliveryAvailable(
      latLng,
      selectedStore
    );
    // console.log("isDeliveryAllow", isDeliveryAllow);
    if (!isDeliveryAllow?.status) {
      alert(
        "The address is still outside of our delivery area. You can try a different address."
      );
      // setErrorCustom(setError, 'full_address', 'The address is still outside of our delivery area. You can try a different address.');
      return;
    }
    let selectedLatdata = isDeliveryAllow?.matchedAreaData;

    setAddressValue({});
    setSelectSavedAddress(uniqueAddress);
    setIsSavedChange(true);
    setErrorCustom(setError, "full_address", "");

    // @@ set minimum price and  form type
    clearAndSetSavedData(
      selectedLatdata?.minimum_order_fees,
      { ...e, price: selectedLatdata?.price },
      arraddressSelectType[0]
    );
  };

  // @@ address type selection
  const handleSelectAddressType = (val: any) => {
    // Konsole.log("address", val);
    setValue("address_type", val);
    setIsRender(!isRender);
  };

  // @@ save and select address btn
  const handleSaveBtn = async (e: any) => {
    // @@ for saved address data
    if (addressSelectFormType == arraddressSelectType[0]) {
      if (isSavedChange) {
        setMinimumPriceAndAddressData(
          dispatch,
          savedAddressMinPrice,
          savedSelectedData
        );
      }
      handleClose();
      return;
    }

    // @@ validate form
    const isValidate = await trigger([
      "address_type",
      "full_address",
      // "zip_code",
      "city",
      "street_name",
      "country",
      'house_no'
    ]);
    // console.log("isValidate", isValidate)
    if (isValidate) {
      handleSaveAddress();
    } else {
      handleSubmit(formSubmit)();
    }
  };

  // @@ submit form
  const formSubmit = (e: any) => {
    // console.log("formSubmit", e);
    handleSaveAddress();
  };

  // @@ saved and select address based on condition
  const handleSaveAddress = async () => {
    let jsonFormData = returnAddressFormJson(getValues);
    // console.log("jsonFormData", jsonFormData);
    // return;
    try {
      dispatch(SETLOADER(true));
      const Url = jsonFormData?.id
        ? "update/user/address"
        : "save/user/address";
      const { data } = await axiosInstance.postForm(Url, jsonFormData);

      if (data?.success) {
        GetAllAddress(dispatch);
        // @@ only save
        if (isAddressAddEdit) {
          const msg = `Address ${actionType == "ADD" ? "saved" : "updated"
            } successfully`;
          SuccessToast(msg);
          handleClose();
          return;
        } else {
          const resAddress = data?.user_address || data?.user_address_list;
          let minimum_order_fee = isDeliveryAllowFunData?.minimum_order_fees;
          let price = isDeliveryAllowFunData?.price;

          // @@ if price and minimul order fee not than again match data and show erroe
          if (!price || !minimum_order_fee) {
            let latLng = {
              lat: Number(resAddress?.lattitude),
              lng: Number(resAddress?.longitude),
            };
            let isDeliveryAllow = CheckStoreAreaDeliveryAvailable(
              latLng,
              selectedStore
            );
            if (!isDeliveryAllow?.status) {
              setErrorCustom(
                setError,
                "full_address",
                "The address is still outside of our delivery area. You can try a different address."
              );
              setAddressValue({});
              return;
            }
            minimum_order_fee =
              isDeliveryAllow?.matchedAreaData?.minimum_order_fees;
            price = isDeliveryAllow?.matchedAreaData?.price;
          }
          setMinimumPriceAndAddressData(dispatch, minimum_order_fee, {
            ...resAddress,
            price: price,
          });
          handleClose();
        }
      }
    } catch (error: any) {
      // console.log("error:-", error)
      console.log("error", error?.response?.data?.message, error);
      setErrorCustom(setError, "full_address", error?.response?.data?.message);
      scrollToFullAddress();
    } finally {
      dispatch(SETLOADER(false));
    }
  };

  function scrollToFullAddress() {
    const element = document.getElementById("POST_CODE");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      element.focus(); // optional: put cursor inside input
    }
  }

  const returnErrorMsg = (msg: any) => {
    return <p className="text-[#ED2323] textMd font-normal">{msg}</p>;
  };

  // console.log("errors", errors);
  // console.log("address", address)
  return (
    <>
      <Modal
        open={addressModal}
        onClose={handleClose}
        center
        // body-scroll-lock only lets the modal box itself scroll on iOS, which blocks
        // the inner list below; html/body are already overflow:hidden (App.css)
        blockScroll={false}
        classNames={{
          overlay: "customOverlay",
          modal: "modalMd",
          closeIcon: "modal-close",
        }}
      >
        {/* @@ modal header */}
        <div className="flex justify-between px-5 py-4 sticky top-0 bg-white z-50">
          <p className="font-splekta text-2xl ">Addresses</p>
        </div>
        <div className="px-5 sticky-touch-element h-full max-h-[30rem] overflow-y-auto overscroll-contain pb-36">
          {/* @@ START SEARCH ADDRES BLOCK */}

          <PlacesAutocomplete
            value={getValues("full_address") ? getValues("full_address") : ""}
            onChange={handleChange}
            onSelect={handleSelect}
            searchOptions={{
              // types: ['address'],
              componentRestrictions: { country: "in" },
            }}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => (
              <div>
                <div
                  id="POST_CODE"
                  className="relative w-full border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 mb-4"
                >
                  <div className="absolute left-4 top-4 text-muted-foreground">
                    <i className="fa fa-search cursor-pointer" />
                  </div>
                  <input
                    {...register("full_address")}
                    {...getInputProps({ placeholder: "Search Location" })}
                    type="search"
                    className="pl-6 bg-transparent placeholder:[#535353] border-none text-base w-full"
                  />
                </div>
                {errors.full_address?.message
                  ? returnErrorMsg(t(errors.full_address?.message))
                  : null}

                <div style={{ zIndex: "99999" }}>
                  {loading && <div>Loading...</div>}
                  {!(getValues("longitude") && getValues("lattitude")) &&
                    !loading &&
                    getValues("full_address") &&
                    suggestions.length == 0 && <div>No results found</div>}
                  {suggestions.map((suggestion: any, index: any) => (
                    <div
                      className="border-b"
                      {...getSuggestionItemProps(suggestion)}
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        background: suggestion.active ? "#d3d3d3" : "#fff",
                      }}
                    >
                      {suggestion.description}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </PlacesAutocomplete>

          {getValues("longitude") && getValues("lattitude") && (
            <>
              <form onSubmit={handleSubmit(formSubmit)}>
                <div>
                  {/* <input
                                    className="w-full cursor-not-allowed border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 text-base mb-2"
                                    type="text"
                                    // name="full_address"
                                    placeholder={t("MyAddress.enterFullAddress")}
                                    {...register("full_address")}
                                    disabled
                                />
                                {errors.full_address?.message ? returnErrorMsg(t(errors.full_address?.message)) : null} */}
                  <input
                    className="w-full border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 text-base mb-2"
                    type="text"
                    placeholder={t("MyAddress.enterHouseNo")}
                    {...register("house_no")}
                  />
                  {errors.house_no?.message
                    ? returnErrorMsg(t(errors.house_no?.message))
                    : null}

                  <input
                    className="w-full border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 text-base mb-2"
                    type="text"
                    {...register("street_name")}
                    placeholder={t("MyAddress.enterStreetName")}
                  />
                  {errors.street_name?.message
                    ? returnErrorMsg(t(errors.street_name?.message))
                    : null}
                  <input
                    className="w-full border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 text-base mb-2"
                    type="text"
                    placeholder={t("MyAddress.enterCity")}
                    {...register("city")}
                  />
                  {errors.city?.message
                    ? returnErrorMsg(t(errors.city?.message))
                    : null}
                  {/* <input
                    className="w-full border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 text-base mb-2"
                    type="text"
                    placeholder={t("MyAddress.enterZipCode")}
                    {...register("zip_code")}
                  />
                  {errors.zip_code?.message
                    ? returnErrorMsg(t(errors.zip_code?.message))
                    : null} */}

                  <input
                    className="w-full border border-[#E7E7E7] bg-[#F5F5F5] rounded-sm p-4 text-base mb-2"
                    type="text"
                    placeholder={t("MyAddress.enterCountry")}
                    {...register("country")}
                  />
                  {errors.country?.message
                    ? returnErrorMsg(t(errors.country?.message))
                    : null}
                </div>
              </form>
              <div className="mb-4">
                <AddressTypeSelector
                  addressType={getValues("address_type")}
                  handleSelectAddressType={handleSelectAddressType}
                />
                {errors.address_type?.message
                  ? returnErrorMsg(t(errors.address_type?.message))
                  : null}
              </div>
            </>
          )}

          {!isAddressAddEdit && (
            <>
              {/* @@ Saved Address Select */}
              {address?.length > 0 ? (
                <>
                  <hr className="mb-2" />
                  <p className="font-splekta text-2xl" id="SAVED_ADDRESS">
                    Saved Addresses
                  </p>

                  {address?.map((adItem: any, adIndex: number) => {
                    const itemName = `${adIndex}${adItem?.zip_code}`;
                    const uniqueAddress = `${adItem?.zip_code}${adItem?.full_address}`;
                    // const houseNo=
                    // console.log('adItem', adItem)
                    return (
                      <>
                        {/* <div key={adIndex} className="chooseVariation w-full new-chooseVariation "
                                        onClick={(e) => onHandleDropDownClick(e, adItem, uniqueAddress)}
                                    >
                                        <input type="radio"
                                            checked={selectSavedAddress == uniqueAddress}
                                            className="" id={itemName} name={itemName} />
                                        <label htmlFor={itemName}>
                                            <div className="variation_option ">
                                                <p className="font-bold text-base">{adItem?.zip_code}</p>
                                                <p className="font-normal text-[#535353] textMd">
                                                    {adItem?.full_address}
                                                </p>
                                            </div>
                                        </label>
                                    </div> */}

                        <div
                          id={"adIndex"}
                          key={adIndex}
                          className="chooseVariation w-full new-chooseVariation cursor-pointer "
                          onClick={(e) =>
                            onHandleDropDownClick(e, adItem, uniqueAddress)
                          }
                        >
                          <div className="flex justify-between items-center">
                            <label htmlFor={itemName}>
                              <div className="variation_option cursor-pointer  ">
                                {/* {adItem?.house_no &&  <span className="font-bold text-base">
                                  {adItem?.house_no}
                                </span>} */}
                                <p className="font-normal text-[#535353] textMd">
                                  {adItem?.house_no && <span className="font-bold">
                                    {adItem?.house_no},
                                  </span>}  {adItem?.full_address}
                                </p>
                              </div>
                            </label>
                            <input
                              type="radio"
                              checked={selectSavedAddress == uniqueAddress}
                              className="w-5 h-5 accent-black shrink-0 cursor-pointer "
                              id={itemName}
                              name={itemName}
                            />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </>
              ) : null}
              {/* @@ Saved address select */}
            </>
          )}
        </div>

        <div className="address-modal-footer fixed bottom-0 w-full px-5 py-4 z-50 bg-white">
          {loader ? (
            <LoaderButton />
          ) : (
            <button
              type="submit"
              className="btn-secondary w-full mb-3"
              onClick={handleSaveBtn}
            >
              {addressSelectFormType == arraddressSelectType[0]
                ? "Select"
                : "Save"}
            </button>
          )}
          {/* <LoaderButton />  */}

          <button
            className="btn-border-sky w-full"
            onClick={() => {
              handleClose();
              // actionType == "ADD" ? resetSelectedAddress({}) : null;
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddressGoogleSearch;
